import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-tabs-wide-nav], [xpoTabsWideNav]',
  host: { class: 'xpo-Tabs-wideNav' },
})
export class XpoTabsWideNavDirective {}
